import { useState } from 'react';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [totalIncome, setTotalIncome] = useState(0);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  return {
    loading,
    setLoading,
    totalIncome, setTotalIncome,
    filterParams,
    setFilterParams,
    size, setSize,
    page, setPage

  };
};

export default useCustomHook;
